export default __webpack_public_path__ + "static/media/Broadcast.87be74ea.svg";